import React, {useEffect} from 'react'
import {Box, Stack, Link} from '@salesforce/retail-react-app/app/components/shared/ui'
import CloudinaryImage from '../../../cloudinary-media/image'
import Title from './partials/title'
import PDButton from '../../components/pd-button'
import PropTypes from 'prop-types'
import {RESIZE_FULL_MOBILE_ONE_TWO_DESKTOP} from '../../../../constants'
import Video from '../hero/partials/video'
import usePdTagManager from '../../../../hooks/use-pd-tag-manager'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'

export const ImageRowOfTwo = (props) => {
    const {
        // First Video Details
        eagerLoadImage = false,
        desktopVideo1,
        desktopVideoThumbnail1,
        mobileVideo1,
        mobileVideoThumbnail1,
        videoAlt1,
        videoEnableSound1,
        videoDisableAutoPlay1,

        // First Image Banner Title
        title1,
        title1Tag,
        title1Color,
        titleFontFamily1,

        // First Image Banner Buttons configs
        button1Link_1,
        button1Text_1,
        button2Link_1,
        button2Text_1,

        // First Image Banner URLs
        cloudinary_background_image1,
        cloudinary_background_mobile_image1,
        cloudinary_background_image_alt1,
        overlayLink1,
        overlayLinkAriaLabel1,

        // Second Image Banner Title
        title2,
        title2Tag,
        title2Color,
        titleFontFamily2,

        // Second Image Banner Buttons configs
        button1Link_2,
        button1Text_2,
        button2Text_2,
        button2Link_2,

        // First Button Configs
        button1Text_1_type = 'button',
        button1Text_1_text_color,
        button1Text_1_bg_color,

        // Second Button Configs
        button2Text_1_type = 'button',
        button2Text_1_text_color,
        button2Text_1_bg_color,

        button2DropdownLinkLabel1_1,
        button2DropdownLinkUrl1_1,
        button2DropdownLinkLabel2_1,
        button2DropdownLinkUrl2_1,
        button2DropdownLinkLabel3_1,
        button2DropdownLinkUrl3_1,
        button2DropdownLinkLabel4_1,
        button2DropdownLinkUrl4_1,
        button2DropdownLinkLabel5_1,
        button2DropdownLinkUrl5_1,
        button2DropdownLinkLabel6_1,
        button2DropdownLinkUrl6_1,

        button1DropdownLinkLabel1_1,
        button1DropdownLinkUrl1_1,
        button1DropdownLinkLabel2_1,
        button1DropdownLinkUrl2_1,
        button1DropdownLinkLabel3_1,
        button1DropdownLinkUrl3_1,
        button1DropdownLinkLabel4_1,
        button1DropdownLinkUrl4_1,
        button1DropdownLinkLabel5_1,
        button1DropdownLinkUrl5_1,
        button1DropdownLinkLabel6_1,
        button1DropdownLinkUrl6_1,

        button2DropdownLinkLabel1_2,
        button2DropdownLinkUrl1_2,
        button2DropdownLinkLabel2_2,
        button2DropdownLinkUrl2_2,
        button2DropdownLinkLabel3_2,
        button2DropdownLinkUrl3_2,
        button2DropdownLinkLabel4_2,
        button2DropdownLinkUrl4_2,
        button2DropdownLinkLabel5_2,
        button2DropdownLinkUrl5_2,
        button2DropdownLinkLabel6_2,
        button2DropdownLinkUrl6_2,

        button1DropdownLinkLabel1_2,
        button1DropdownLinkUrl1_2,
        button1DropdownLinkLabel2_2,
        button1DropdownLinkUrl2_2,
        button1DropdownLinkLabel3_2,
        button1DropdownLinkUrl3_2,
        button1DropdownLinkLabel4_2,
        button1DropdownLinkUrl4_2,
        button1DropdownLinkLabel5_2,
        button1DropdownLinkUrl5_2,
        button1DropdownLinkLabel6_2,
        button1DropdownLinkUrl6_2,

        // First Button Configs
        button1Text2_type = 'button',
        button1Text_2_text_color,
        button1Text_2_bg_color,

        button2Text2_type,
        button2Text_2_text_color,
        button2Text_2_bg_color,

        // Second Video Details
        desktopVideo2,
        desktopVideoThumbnail2,
        mobileVideo2,
        mobileVideoThumbnail2,
        videoAlt2,
        videoEnableSound2,
        videoDisableAutoPlay2,

        // Second Image Banner URLs
        cloudinary_background_image2,
        cloudinary_background_mobile_image2,
        cloudinary_background_image_alt2,
        overlayLink2,
        overlayLinkAriaLabel2,

        typeId,
        name
    } = props
    const pdTagManager = usePdTagManager()
    const appOrigin = useAppOrigin()
    let links1_1 = []
    if (button1DropdownLinkLabel1_1 && button1DropdownLinkUrl1_1) {
        links1_1.push({label: button1DropdownLinkLabel1_1, url: button1DropdownLinkUrl1_1})
    }
    if (button1DropdownLinkLabel2_1 && button1DropdownLinkUrl2_1) {
        links1_1.push({label: button1DropdownLinkLabel2_1, url: button1DropdownLinkUrl2_1})
    }
    if (button1DropdownLinkLabel3_1 && button1DropdownLinkUrl3_1) {
        links1_1.push({label: button1DropdownLinkLabel3_1, url: button1DropdownLinkUrl3_1})
    }
    if (button1DropdownLinkLabel4_1 && button1DropdownLinkUrl4_1) {
        links1_1.push({label: button1DropdownLinkLabel4_1, url: button1DropdownLinkUrl4_1})
    }
    if (button1DropdownLinkLabel5_1 && button1DropdownLinkUrl5_1) {
        links1_1.push({label: button1DropdownLinkLabel5_1, url: button1DropdownLinkUrl5_1})
    }
    if (button1DropdownLinkLabel6_1 && button1DropdownLinkUrl6_1) {
        links1_1.push({label: button1DropdownLinkLabel6_1, url: button1DropdownLinkUrl6_1})
    }

    let links2_1 = []
    if (button2DropdownLinkLabel1_1 && button2DropdownLinkUrl1_1) {
        links2_1.push({label: button2DropdownLinkLabel1_1, url: button2DropdownLinkUrl1_1})
    }
    if (button2DropdownLinkLabel2_1 && button2DropdownLinkUrl2_1) {
        links2_1.push({label: button2DropdownLinkLabel2_1, url: button2DropdownLinkUrl2_1})
    }
    if (button2DropdownLinkLabel3_1 && button2DropdownLinkUrl3_1) {
        links2_1.push({label: button2DropdownLinkLabel3_1, url: button2DropdownLinkUrl3_1})
    }
    if (button2DropdownLinkLabel4_1 && button2DropdownLinkUrl4_1) {
        links2_1.push({label: button2DropdownLinkLabel4_1, url: button2DropdownLinkUrl4_1})
    }
    if (button2DropdownLinkLabel5_1 && button2DropdownLinkUrl5_1) {
        links2_1.push({label: button2DropdownLinkLabel5_1, url: button2DropdownLinkUrl5_1})
    }
    if (button2DropdownLinkLabel6_1 && button2DropdownLinkUrl6_1) {
        links2_1.push({label: button2DropdownLinkLabel6_1, url: button2DropdownLinkUrl6_1})
    }

    let links1_2 = []
    if (button1DropdownLinkLabel1_2 && button1DropdownLinkUrl1_2) {
        links1_2.push({label: button1DropdownLinkLabel1_2, url: button1DropdownLinkUrl1_2})
    }
    if (button1DropdownLinkLabel2_2 && button1DropdownLinkUrl2_2) {
        links1_2.push({label: button1DropdownLinkLabel2_2, url: button1DropdownLinkUrl2_2})
    }
    if (button1DropdownLinkLabel3_2 && button1DropdownLinkUrl3_2) {
        links1_2.push({label: button1DropdownLinkLabel3_2, url: button1DropdownLinkUrl3_2})
    }
    if (button1DropdownLinkLabel4_2 && button1DropdownLinkUrl4_2) {
        links1_2.push({label: button1DropdownLinkLabel4_2, url: button1DropdownLinkUrl4_2})
    }
    if (button1DropdownLinkLabel5_2 && button1DropdownLinkUrl5_2) {
        links1_2.push({label: button1DropdownLinkLabel5_2, url: button1DropdownLinkUrl5_2})
    }
    if (button1DropdownLinkLabel6_2 && button1DropdownLinkUrl6_2) {
        links1_2.push({label: button1DropdownLinkLabel6_2, url: button1DropdownLinkUrl6_2})
    }

    let links2_2 = []
    if (button2DropdownLinkLabel1_2 && button2DropdownLinkUrl1_2) {
        links2_2.push({label: button2DropdownLinkLabel1_2, url: button2DropdownLinkUrl1_2})
    }
    if (button2DropdownLinkLabel2_2 && button2DropdownLinkUrl2_2) {
        links2_2.push({label: button2DropdownLinkLabel2_2, url: button2DropdownLinkUrl2_2})
    }
    if (button2DropdownLinkLabel3_2 && button2DropdownLinkUrl3_2) {
        links2_2.push({label: button2DropdownLinkLabel3_2, url: button2DropdownLinkUrl3_2})
    }
    if (button2DropdownLinkLabel4_2 && button2DropdownLinkUrl4_2) {
        links2_2.push({label: button2DropdownLinkLabel4_2, url: button2DropdownLinkUrl4_2})
    }
    if (button2DropdownLinkLabel5_2 && button2DropdownLinkUrl5_2) {
        links2_2.push({label: button2DropdownLinkLabel5_2, url: button2DropdownLinkUrl5_2})
    }
    if (button2DropdownLinkLabel6_2 && button2DropdownLinkUrl6_2) {
        links2_2.push({label: button2DropdownLinkLabel6_2, url: button2DropdownLinkUrl6_2})
    }
    const shouldDisplayVideo1 = desktopVideo1 || mobileVideo1
    const shouldDisplayVideo2 = desktopVideo2 || mobileVideo2

    useEffect(() => {
        pdTagManager.viewComponent(typeId, name, 2)
    }, [])

    const selectComponent = (title, titlePosition, linkUrl, imageUrl, videoUrl) => {
        pdTagManager.selectComponent({
            componentId: typeId,
            componentName: name,
            titleName: title,
            titlePosition: titlePosition,
            linkUrl: linkUrl,
            imageUrl: imageUrl,
            videoUrl: videoUrl
        })
    }

    return (
        <Box width="100%" display="grid" gridTemplateColumns={{base: '1fr', md: '1fr 1fr'}} gap="0">
            <Box position="relative" width="100%" display="flex">
                {shouldDisplayVideo1 ? (
                    <Video
                        desktopVideo={desktopVideo1}
                        mobileVideo={mobileVideo1 || desktopVideo1}
                        desktopVideoThumbnail={desktopVideoThumbnail1}
                        mobileVideoThumbnail={mobileVideoThumbnail1}
                        videoDisableAutoPlay={videoDisableAutoPlay1}
                        videoEnableSound={videoEnableSound1}
                        videoAlt={videoAlt1}
                    />
                ) : (
                    <Box gridArea={{base: '475 / 428', md: '720 / 832'}}>
                        <CloudinaryImage
                            src={cloudinary_background_image1}
                            aspectRatio="865:1000"
                            styles={{
                                display: {base: 'none', md: 'block'},
                                aspectRatio: '865 / 1000',
                                width: '100%',
                                height: 'auto',
                                htmlWidth: 865,
                                htmlHeight: 1000
                            }}
                            imgSizes={{lg: '50vw', md: '50vw', base: '100vw'}}
                            sizes={RESIZE_FULL_MOBILE_ONE_TWO_DESKTOP}
                            alt={cloudinary_background_image_alt1}
                            lazyload={!eagerLoadImage}
                        />
                        <CloudinaryImage
                            src={cloudinary_background_mobile_image1}
                            aspectRatio="111:100"
                            styles={{
                                display: {base: 'block', md: 'none'},
                                aspectRatio: '111 / 100',
                                width: '100%',
                                height: 'auto',
                                htmlWidth: 111,
                                htmlHeight: 100
                            }}
                            imgSizes={{lg: '50vw', md: '50vw', base: '100vw'}}
                            sizes={RESIZE_FULL_MOBILE_ONE_TWO_DESKTOP}
                            alt={cloudinary_background_image_alt1}
                            lazyload={!eagerLoadImage}
                        />

                        {overlayLink1 && (
                            <Link
                                href={overlayLink1}
                                onClick={() => {
                                    selectComponent(
                                        title1,
                                        0,
                                        overlayLink1?.indexOf('http') !== -1
                                            ? overlayLink1
                                            : `${appOrigin}${overlayLink1}`,
                                        cloudinary_background_image1,
                                        shouldDisplayVideo1 ? desktopVideo1 : ''
                                    )
                                }}
                                aria-label={overlayLinkAriaLabel1 || title1}
                                position="absolute"
                                top="0"
                                left="0"
                                width="100%"
                                height="100%"
                            />
                        )}
                    </Box>
                )}
                <Box
                    position="absolute"
                    bottom="0"
                    left="0"
                    width="100%"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    padding={{base: '30px 30px 0px 30px', md: '30px'}}
                    marginBottom={{base: '20px', md: '26px', lg: '12.5px', xl: '22.5px'}}
                    color="white"
                >
                    {title1 && (
                        <Title
                            title={title1}
                            tag={title1Tag}
                            color={title1Color}
                            titleFontFamily={titleFontFamily1}
                            titleSizeMobile={'36px'}
                            titleSizeTablet={'36px'}
                            titleSizeDesktop={'48px'}
                            titleSizeXl={'64px'}
                        />
                    )}

                    <Stack
                        direction="row"
                        margin="20px 0 5px 0"
                        display="flex"
                        flexWrap="wrap"
                        justifyContent="center"
                        rowGap="10px"
                        minHeight="70px"
                        className="promo-buttons-wrapper"
                        columnGap={{base: '10px', lg: '60px'}}
                        alignItems="baseline"
                    >
                        {button1Text_1 && (
                            <PDButton
                                text={button1Text_1}
                                url={button1Link_1}
                                color={button1Text_1_text_color}
                                buttonBackgroundColor={button1Text_1_bg_color}
                                ctaType={button1Text_1_type}
                                links={links1_1}
                                typeId={typeId}
                                name={name}
                                titlePosition={0}
                                imageUrl={cloudinary_background_image1}
                                videoUrl={shouldDisplayVideo1 ? desktopVideo1 : ''}
                            />
                        )}
                        {button2Text_1 && (
                            <PDButton
                                text={button2Text_1}
                                url={button2Link_1}
                                color={button2Text_1_text_color}
                                buttonBackgroundColor={button2Text_1_bg_color}
                                ctaType={button2Text_1_type}
                                links={links2_1}
                                typeId={typeId}
                                name={name}
                                titlePosition={0}
                                imageUrl={cloudinary_background_image1}
                                videoUrl={shouldDisplayVideo1 ? desktopVideo1 : ''}
                            />
                        )}
                    </Stack>
                </Box>
            </Box>
            <Box position="relative" width="100%" display="flex">
                {shouldDisplayVideo2 ? (
                    <Video
                        desktopVideo={desktopVideo2}
                        mobileVideo={mobileVideo2 || desktopVideo2}
                        desktopVideoThumbnail={desktopVideoThumbnail2}
                        mobileVideoThumbnail={mobileVideoThumbnail2}
                        videoDisableAutoPlay={videoDisableAutoPlay2}
                        videoEnableSound={videoEnableSound2}
                        videoAlt={videoAlt2}
                    />
                ) : (
                    <Box gridArea={{base: '475 / 428', md: '720 / 832'}}>
                        <CloudinaryImage
                            src={cloudinary_background_image2}
                            aspectRatio="865:1000"
                            styles={{
                                display: {base: 'none', md: 'block'},
                                aspectRatio: '865 / 1000',
                                width: '100%',
                                height: 'auto',
                                htmlWidth: 865,
                                htmlHeight: 1000
                            }}
                            imgSizes={{lg: '50vw', md: '50vw', base: '100vw'}}
                            sizes={RESIZE_FULL_MOBILE_ONE_TWO_DESKTOP}
                            alt={cloudinary_background_image_alt2}
                            lazyload={!eagerLoadImage}
                        />
                        <CloudinaryImage
                            src={cloudinary_background_mobile_image2}
                            aspectRatio="111:100"
                            styles={{
                                display: {base: 'block', md: 'none'},
                                aspectRatio: '111 / 100',
                                width: '100%',
                                height: 'auto',
                                htmlWidth: 111,
                                htmlHeight: 100
                            }}
                            imgSizes={{lg: '50vw', md: '50vw', base: '100vw'}}
                            sizes={RESIZE_FULL_MOBILE_ONE_TWO_DESKTOP}
                            alt={cloudinary_background_image_alt2}
                            lazyload={!eagerLoadImage}
                        />

                        {overlayLink2 && (
                            <Link
                                href={overlayLink2}
                                onClick={() => {
                                    selectComponent(
                                        title2,
                                        1,
                                        overlayLink2?.indexOf('http') !== -1
                                            ? overlayLink2
                                            : `${appOrigin}${overlayLink2}`,
                                        cloudinary_background_image2,
                                        shouldDisplayVideo2 ? desktopVideo2 : ''
                                    )
                                }}
                                aria-label={overlayLinkAriaLabel2 || title2}
                                position="absolute"
                                top="0"
                                left="0"
                                width="100%"
                                height="100%"
                            />
                        )}
                    </Box>
                )}
                <Box
                    position="absolute"
                    bottom="0"
                    left="0"
                    width="100%"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    padding={{base: '30px 30px 0px 30px', md: '30px'}}
                    marginBottom={{base: '20px', md: '26px', lg: '12.5px', xl: '22.5px'}}
                    color="white"
                >
                    {title2 && (
                        <Title
                            title={title2}
                            tag={title2Tag}
                            color={title2Color}
                            titleFontFamily={titleFontFamily2}
                            titleSizeMobile={'36px'}
                            titleSizeTablet={'36px'}
                            titleSizeDesktop={'48px'}
                            titleSizeXl={'64px'}
                        />
                    )}
                    <Stack
                        direction="row"
                        margin="20px 0 5px 0"
                        display="flex"
                        flexWrap="wrap"
                        justifyContent="center"
                        rowGap="10px"
                        minHeight="70px"
                        className="promo-buttons-wrapper"
                        columnGap={{base: '10px', lg: '60px'}}
                        alignItems="baseline"
                    >
                        {button1Text_2 && (
                            <PDButton
                                text={button1Text_2}
                                url={button1Link_2}
                                color={button1Text_2_text_color}
                                buttonBackgroundColor={button1Text_2_bg_color}
                                ctaType={button1Text2_type}
                                links={links1_2}
                                typeId={typeId}
                                name={name}
                                titlePosition={1}
                                imageUrl={cloudinary_background_image2}
                                videoUrl={shouldDisplayVideo2 ? desktopVideo2 : ''}
                            />
                        )}
                        {button2Text_2 && (
                            <PDButton
                                text={button2Text_2}
                                url={button2Link_2}
                                color={button2Text_2_text_color}
                                buttonBackgroundColor={button2Text_2_bg_color}
                                ctaType={button2Text2_type}
                                links={links2_2}
                                typeId={typeId}
                                name={name}
                                titlePosition={1}
                                imageUrl={cloudinary_background_image2}
                                videoUrl={shouldDisplayVideo2 ? desktopVideo2 : ''}
                            />
                        )}
                    </Stack>
                </Box>
            </Box>
        </Box>
    )
}

ImageRowOfTwo.displayName = 'ImageRowOfTwo'

ImageRowOfTwo.propTypes = {
    eagerLoadImage: PropTypes.bool,
    // First Image Banner Title
    title1: PropTypes.string,
    title1Tag: PropTypes.string,
    title1Color: PropTypes.string,
    titleFontFamily1: PropTypes.string,

    // First Image Banner Buttons configs
    button1Link_1: PropTypes.string,
    button1Text_1: PropTypes.string,
    button2Link_1: PropTypes.string,
    button2Text_1: PropTypes.string,
    button2Text_1_type: PropTypes.string,
    buttonsColor_1: PropTypes.string,
    cta1SizeMobile: PropTypes.string,
    cta1SizeDesktop: PropTypes.string,

    // First Image Banner URLs
    cloudinary_background_image1: PropTypes.string,
    cloudinary_background_mobile_image1: PropTypes.string,
    cloudinary_background_image_alt1: PropTypes.string,
    overlayLink1: PropTypes.string,
    overlayLinkAriaLabel1: PropTypes.string,

    titleFontFamily2: PropTypes.string,

    // Second Image Banner Buttons configs
    button1Link_2: PropTypes.string,
    button1Text_2: PropTypes.string,
    button2Text_2: PropTypes.string,
    button2Link_2: PropTypes.string,
    cta2SizeMobile: PropTypes.string,
    cta2SizeDesktop: PropTypes.string,

    // Second Image Banner URLs
    cloudinary_background_image2: PropTypes.string,
    cloudinary_background_mobile_image2: PropTypes.string,
    cloudinary_background_image_alt2: PropTypes.string,
    overlayLink2: PropTypes.string,
    overlayLinkAriaLabel2: PropTypes.string,

    button1Text_1_text_color: PropTypes.string,
    button1Text_1_type: PropTypes.string,
    button1Text_1_bg_color: PropTypes.string,
    button2Text_type: PropTypes.string,
    button2Text_1_text_color: PropTypes.string,
    button2Text_1_bg_color: PropTypes.string,
    button1Text2_type: PropTypes.string,
    button1Text_2_text_color: PropTypes.string,
    button1Text_2_bg_color: PropTypes.string,
    button2Text2_type: PropTypes.string,
    button2Text_2_text_color: PropTypes.string,
    button2Text_2_bg_color: PropTypes.string,

    title2: PropTypes.string,
    title2Tag: PropTypes.string,
    title2Color: PropTypes.string,

    button1DropdownLinkLabel1_1: PropTypes.string,
    button1DropdownLinkUrl1_1: PropTypes.string,
    button1DropdownLinkLabel2_1: PropTypes.string,
    button1DropdownLinkUrl2_1: PropTypes.string,
    button1DropdownLinkLabel3_1: PropTypes.string,
    button1DropdownLinkUrl3_1: PropTypes.string,
    button1DropdownLinkLabel4_1: PropTypes.string,
    button1DropdownLinkUrl4_1: PropTypes.string,
    button1DropdownLinkLabel5_1: PropTypes.string,
    button1DropdownLinkUrl5_1: PropTypes.string,
    button1DropdownLinkLabel6_1: PropTypes.string,
    button1DropdownLinkUrl6_1: PropTypes.string,

    button2DropdownLinkLabel1_1: PropTypes.string,
    button2DropdownLinkUrl1_1: PropTypes.string,
    button2DropdownLinkLabel2_1: PropTypes.string,
    button2DropdownLinkUrl2_1: PropTypes.string,
    button2DropdownLinkLabel3_1: PropTypes.string,
    button2DropdownLinkUrl3_1: PropTypes.string,
    button2DropdownLinkLabel4_1: PropTypes.string,
    button2DropdownLinkUrl4_1: PropTypes.string,
    button2DropdownLinkLabel5_1: PropTypes.string,
    button2DropdownLinkUrl5_1: PropTypes.string,
    button2DropdownLinkLabel6_1: PropTypes.string,
    button2DropdownLinkUrl6_1: PropTypes.string,

    button1DropdownLinkLabel1_2: PropTypes.string,
    button1DropdownLinkUrl1_2: PropTypes.string,
    button1DropdownLinkLabel2_2: PropTypes.string,
    button1DropdownLinkUrl2_2: PropTypes.string,
    button1DropdownLinkLabel3_2: PropTypes.string,
    button1DropdownLinkUrl3_2: PropTypes.string,
    button1DropdownLinkLabel4_2: PropTypes.string,
    button1DropdownLinkUrl4_2: PropTypes.string,
    button1DropdownLinkLabel5_2: PropTypes.string,
    button1DropdownLinkUrl5_2: PropTypes.string,
    button1DropdownLinkLabel6_2: PropTypes.string,
    button1DropdownLinkUrl6_2: PropTypes.string,

    button2DropdownLinkLabel1_2: PropTypes.string,
    button2DropdownLinkUrl1_2: PropTypes.string,
    button2DropdownLinkLabel2_2: PropTypes.string,
    button2DropdownLinkUrl2_2: PropTypes.string,
    button2DropdownLinkLabel3_2: PropTypes.string,
    button2DropdownLinkUrl3_2: PropTypes.string,
    button2DropdownLinkLabel4_2: PropTypes.string,
    button2DropdownLinkUrl4_2: PropTypes.string,
    button2DropdownLinkLabel5_2: PropTypes.string,
    button2DropdownLinkUrl5_2: PropTypes.string,
    button2DropdownLinkLabel6_2: PropTypes.string,
    button2DropdownLinkUrl6_2: PropTypes.string,

    desktopVideo1: PropTypes.string,
    desktopVideoThumbnail1: PropTypes.string,
    mobileVideo1: PropTypes.string,
    mobileVideoThumbnail1: PropTypes.string,
    videoAlt1: PropTypes.string,
    videoEnableSound1: PropTypes.string,
    videoDisableAutoPlay1: PropTypes.string,

    desktopVideo2: PropTypes.string,
    desktopVideoThumbnail2: PropTypes.string,
    mobileVideo2: PropTypes.string,
    mobileVideoThumbnail2: PropTypes.string,
    videoAlt2: PropTypes.string,
    videoEnableSound2: PropTypes.string,
    videoDisableAutoPlay2: PropTypes.string,

    typeId: PropTypes.string,
    name: PropTypes.any
}

export default ImageRowOfTwo
